import * as React from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import { Item } from "../model/search-base-model";
import { Button, makeStyles } from "@material-ui/core";
import Carousel from "react-material-ui-carousel";
import { useDispatch } from "react-redux";
import { setSelectedItem, setShowDetail } from "../slice/search-slice";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 450,
  },
}));

interface ItemCardProps {
  item: Item;
}
export default function ItemCard(props: ItemCardProps) {
  const { item } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const openModel = () => {
    dispatch(setSelectedItem(item));
    dispatch(setShowDetail(true));
  };
  return (
    <Card className={classes.root}>
      <CardHeader title={item?.name} subheader="Sub header" />
      <Carousel autoPlay={false}>
        {item?.imgs?.map((i, idx) => (
          <CardMedia
            key={`${item.name}-${idx}`}
            component="img"
            image={i}
            alt={item?.name}
          />
        ))}
      </Carousel>
      <CardContent>
        <Button variant="outlined" color="primary" onClick={openModel}>
          View Detail
        </Button>
      </CardContent>
    </Card>
  );
}
